import React from "react";
import { Link } from "react-router-dom";
import { BsFillTelephoneFill } from "react-icons/bs";

const ContactUs = () => {
  return (
    <div className="bg-banner-background bg-no-repeat h-auto bg-cover w-full mb-4">
      <div className="w-full h-full bg-primeColor bg-opacity-80">
        <div className="max-w-screen-2xl mx-auto flex flex-col gap-10 items-center py-10 mdl:py-24">
          <div className="w-full flex justify-center">
            <h1 className="text-white font-titleFont text-2xl mdl:text-4xl w-full px-4 mdl:w-2/3 text-center">
              Need a professional English Learning Guideline? Let's discuss your
              case!
            </h1>
          </div>
          <div className="flex flex-col mdl:flex-row items-center gap-6 font-bodyFont ">
            <Link to="/contactus">
              <button className="w-56 bg-darkPink h-14 text-lg rounded-lg text-white hover:bg-white hover:text-darkPink font-semibold transition-hover duration-300">
                Contact us online
              </button>
            </Link>
            <button className="flex flex-row items-center text-lg gap-4 justify-center w-56 border-darkPink hover:border-white border h-14 rounded-lg text-darkPink font-semibold hover:text-white transition-hover duration-300">
              <span>
                <BsFillTelephoneFill className="text-2xl" />
              </span>
              +8801975598780
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
